// src/components/strumenti/Proporzione.js — W442. Regola del tre: a : b = c : x → x = b·c / a
import React from "react";
import { useCampi, Campo, Griglia, Risultato, Formula, Azzera, fmt } from "./UiStrumento";
import { proporzione } from "../../utils/calcoliStrumenti";

export default function Proporzione() {
  const { v, set, n, azzera } = useCampi({ a:"", b:"", c:"" });
  const x = proporzione(n("a"), n("b"), n("c"));
  return (
    <div>
      <div style={{ fontSize:12, color:"#6b7280", marginBottom:10 }}>Se <strong>a</strong> vale <strong>b</strong>, quanto vale <strong>c</strong>? (es. 4 m² costano 10 €, 6 m² costano…)</div>
      <Griglia colonne={3}>
        <Campo etichetta="a" valore={v.a} onChange={set("a")} placeholder="Es. 4"/>
        <Campo etichetta="b (vale)" valore={v.b} onChange={set("b")} placeholder="Es. 10"/>
        <Campo etichetta="c" valore={v.c} onChange={set("c")} placeholder="Es. 6"/>
      </Griglia>
      <Risultato settore="matematica" titolo="x" valore={fmt(x, 4)}/>
      <Formula>a : b = c : x → <strong>x = b × c ÷ a</strong>. Vale per grandezze direttamente proporzionali (doppio della quantità = doppio del valore). Con a = 0 il calcolo non è possibile.</Formula>
      <Azzera onClick={azzera}/>
    </div>
  );
}
